import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import logo2 from '../assets/csvFileHandlerLogo.png'
const MainDiv = styled.div`
position: fixed;
box-sizing: border-box;
text-align: center;
width: 100%;
padding: 6px;
padding-left: 20px;
color: black;
font-weight: bold;
padding-right: 20px;
z-index: 10;
background: #b6e2f7;
`
const LogoDiv = styled.div`
display: flex;
    float: left;
    flex-direction: column;
`

export const Header = () =>{
    return (<MainDiv>
        <LogoDiv >
<img style={{ height: '86px', width:'auto'}} src={logo2} alt="logo" />
{/* <span>CSV FILE HANDLER</span> */}
        </LogoDiv>
       <Link to='/contact'> <div  className={'headerElements'}>
            Contact us
        </div>
        </Link>
    </MainDiv>)
} 